import React from 'react';
import { observer } from 'mobx-react-lite';
import { WebGameColumn, WebGameColumnInner, WebGameMainCont } from '@pascal/pascal-core';

import { WebGame } from './game';
import LeftColumn from '../common/leftColum';
import RightColumn from '../common/rightColumn';
import gameLogo from '../../assets/images/logo.png';
import { PopupsWrapper } from '../common/popUps/wrapper';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';

const Web = observer(() => {
  return (
    <>
      <WebGameMainCont
        hasDemoPopup
        isShowIconTag
        hasGameTypeLoading
        isShowBogLineLobby
        lobbyLogoImageSrc={gameLogo}
        playForRealPopupImgSrc={playForRealPopupImgSrc}
      >
        <LeftColumn />
        <WebGameColumn position='center'>
          <WebGameColumnInner position='center'>
            <WebGame />
          </WebGameColumnInner>
          <PopupsWrapper />
        </WebGameColumn>
        <RightColumn />
      </WebGameMainCont>
    </>
  );
});

export default Web;
